export default [
  {
    path: '/volume',
    name: 'volume',
    component: () => import(/* webpackChunkName: "elaboracao-volume" */ './Volume')
  }
]
